import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { studentPanelAPI } from '../../services/api';
import { 
  Users, 
  BookOpen,
  GraduationCap,
  Loader2,
  ChevronRight,
  UserCircle
} from 'lucide-react';

const StudentHome = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['student-dashboard'],
    queryFn: () => studentPanelAPI.getDashboard(),
  });

  const stats = data?.data?.stats;
  const group = data?.data?.group;
  const subjects = data?.data?.subjects || [];
  const student = data?.data?.student;

  if (isLoading) {
    return (
      <div className="loading-container">
        <Loader2 className="spinner" size={40} />
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error">
        Ma'lumotlarni yuklashda xatolik yuz berdi
      </div>
    );
  }

  return (
    <>
      {/* Welcome */}
      <div className="welcome-card student-welcome">
        <div className="welcome-text">
          <h2>Xush kelibsiz, {student?.user?.full_name}!</h2>
          {group && (
            <p className="welcome-group">
              <Users size={16} />
              {group.name} • {group.course}-kurs
            </p>
          )}
        </div>
        <div className="welcome-id">
          <span className="student-id">{student?.student_id}</span>
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon purple">
            <BookOpen size={28} />
          </div>
          <div className="stat-info">
            <h3>{stats?.total_subjects || 0}</h3>
            <p>Fanlarim</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon orange">
            <GraduationCap size={28} />
          </div>
          <div className="stat-info">
            <h3>{stats?.total_teachers || 0}</h3>
            <p>O'qituvchilar</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon blue">
            <Users size={28} />
          </div>
          <div className="stat-info">
            <h3>{stats?.group_students || 0}</h3>
            <p>Guruh a'zolari</p>
          </div>
        </div>
      </div>

      {/* Content Grid */}
      <div className="content-grid">
        {/* My Subjects */}
        <div className="card">
          <div className="card-header">
            <h3>Fanlarim</h3>
            <Link to="/student/subjects" className="link-btn">
              Barchasi <ChevronRight size={16} />
            </Link>
          </div>
          <div className="card-body">
            {subjects.length === 0 ? (
              <div className="empty-state small">
                <BookOpen size={32} />
                <p>Fanlar topilmadi</p>
              </div>
            ) : (
              <div className="list-items">
                {subjects.slice(0, 5).map(subject => (
                  <Link 
                    key={subject.id} 
                    to={`/student/subjects/${subject.id}/materials`}
                    className="list-item clickable"
                  >
                    <div className="list-item-icon purple">
                      <BookOpen size={20} />
                    </div>
                    <div className="list-item-content">
                      <div className="list-item-title">{subject.name}</div>
                    </div>
                    <ChevronRight size={18} className="text-muted" />
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Group Info */}
        <div className="card">
          <div className="card-header">
            <h3>Guruhim</h3>
            <Link to="/student/groupmates" className="link-btn">
              Barchasi <ChevronRight size={16} />
            </Link>
          </div>
          <div className="card-body">
            {!group ? (
              <div className="empty-state small">
                <Users size={32} />
                <p>Guruh biriktirilmagan</p>
              </div>
            ) : (
              <div className="group-info-card">
                <div className="group-info-header">
                  <div className="group-info-icon">
                    <Users size={28} />
                  </div>
                  <div>
                    <h4>{group.name}</h4>
                    <p>{group.course}-kurs</p>
                  </div>
                </div>
                <div className="group-info-stats">
                  <div className="info-stat">
                    <UserCircle size={16} />
                    <span>{stats?.group_students} talaba</span>
                  </div>
                  <div className="info-stat">
                    <BookOpen size={16} />
                    <span>{stats?.total_subjects} fan</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentHome;
